import Vue from 'vue'
import App from './App.vue'
// router与store
import router from './router'
import store from './store'
// 引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 全局组件
import '@/components'

// 引入api
import api from './api'
import pub from './public'
import ver from './verification/index.js'
import load from './loading/loading.js'

Vue.prototype.$api = api
Vue.prototype.$pub = pub
Vue.prototype.$ver = ver
Vue.prototype.$load = load

Vue.use(ElementUI)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title
	}
	next()
})
if(pub.getStorage('o_token')){
	let userInfo = JSON.parse(pub.getStorage('o_userInfo'))
	store.commit('saveUserinfo',userInfo)
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
